const CM_TO_INCHES = 1 / 2.54;
const INCHES_TO_CM = 2.54;

export const cmToInches = (cm) => {
  const num =
    typeof cm === "number"
      ? cm
      : typeof cm === "string" && cm.trim() !== ""
        ? Number(cm)
        : NaN;
  if (!Number.isFinite(num)) return cm;
  return num * CM_TO_INCHES;
};

export const inchesToCm = (inches) => {
  const num =
    typeof inches === "number"
      ? inches
      : typeof inches === "string" && inches.trim() !== ""
        ? Number(inches)
        : NaN;
  if (!Number.isFinite(num)) return inches;
  return num * INCHES_TO_CM;
};
